import React, { useState, useRef, useEffect } from "react";
import CircularProgress from '@mui/material/CircularProgress';
import { sendAppLink } from "../../redux/slices/product";
import { useSelector, useDispatch } from "react-redux";
import DoneIcon from "@mui/icons-material/Done";

function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode
      .toUpperCase()
      .replace(/./g, (char) =>
        String.fromCodePoint(char.charCodeAt(0) + 127397)
      )
    : isoCode;
}
const AppBlock = () => {
  const ref0 = useRef();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [validMessage, setValidMessage] = useState(false);
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [datas, setDatas] = useState({
    driverCountryCode: "",
    driverEmail: "",
  });
  const { sendAppRec } = useSelector((state) => state.product);

  const handleChangeAppContent = (value, name) => {
    if (name === "driverCountryCode") {
      setDatas({ ...datas, [name]: `+${value}` });
    } else {
      setDatas({ ...datas, [name]: value });
    }
  };

  const isValidEmail = (email) => {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return re.test(String(email).toLowerCase());
  };

  const handleSendLink = () => {
    if (datas.driverEmail === '' || !isValidEmail(datas?.driverEmail)) {
      setShowValidationMessage(true);
      setValidMessage(false);
      setLoader(false);
    } else {
      setLoader(true);
      dispatch(sendAppLink(datas));
    }
  };
  
  useEffect(() => {
  
    if (sendAppRec) {
      setLoader(false);
      setValidMessage(true);
      
      // Reset validMessage after a delay so the button can reappear
      setTimeout(() => {
        setValidMessage(false);
        setDatas({ ...datas, ['driverEmail']: '' });
        
      }, 3000);
    }
  }, [sendAppRec]);
  
  return (
    <div className="Appbanner-rsl y-gap-30">
      <div className="appBanner-header mt-20">
        <h2 className="mobile-app">SMART RSL APP</h2>
        <p className="appBanner-Header__subtitle text-dark-1 lg:pr-0 mt-5 sm:mt-5">
          Experience luxury travel with RSL.
        </p>
        <p className="appBanner-content lg:pr-0 pt-15 sm:mt-5 mt-20">
          Book premium limousines and chauffeur services at your fingertips.
          Enjoy real-time vehicle tracking, secure payments, and personalized
          itineraries. Our app ensures top-notch safety and comfort, backed by
          professional chauffeurs and a diverse fleet.
        </p>
        <p className="appBanner-content lg:pr-0 pt-15 sm:mt-5 mt-20">
          Elevate your travel experience with Smart RSL - Your Smart Choice for
          Luxury Transportation.
        </p>
        <p className="appBanner-content mt-70">
          Receive a link to download the smart RSL app.
        </p>
      </div>
      <form className="text-15 appBanner-input text-light-1 ls-2 lh-16 mt-20" onSubmit={(e) => {
    e.preventDefault();  // Prevent reload
  }}>
        <div className="input-div" style={{ alignItems: "center" }}>
          <input
            // className="col-12 bg-white h-60"
            type="text"
            placeholder="Your Email"
            required
            value ={datas?.driverEmail}
            onChange={(e) =>
              handleChangeAppContent(e.target.value, "driverEmail")
            }
          />
        </div>
      </form>
      <div className="text-14 text-center" style={{ color: "#6dc8bf" }}>
        {showValidationMessage ? (
          <h6>
            {datas.driverEmail === ""
              ? "*Please enter the email address."
              : !isValidEmail(datas.driverEmail)
                ? "*Please enter a valid email address."
                : ""}
          </h6>
        ) : null}
      </div>
      <div className="appBanner-search text-14 d-flex items-center justify-center mt-20">
        {!loader ? (
        validMessage ? (
          <p style={{ fontSize: "16px" }}>
            <span>
              <DoneIcon style={{ color: "green" }} />
            </span>
            Link shared successfully
          </p>
        ) : (
          <div>
            {showValidationMessage}
            <button type="submit" className="-dark-4 -dark-3 text-white" onClick={handleSendLink}>
              Send App Link
            </button>
          </div>
        )
        ) : <button
          className="-dark-4 -dark-3 text-white d-flex justify-center align-center"
        ><CircularProgress /> </button>}
      </div>
    </div>
  );
};

export default AppBlock;
